<div class="custom-loading-container">
    <img src="assets/images/loading.svg" loading="lazy" />
</div>
